import { useNavigate } from "react-router-dom";

const Moonshots = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:flex-row px-1 pt-5 max-w-9xl mx-auto">
        <div>
          <h2 className="font-semibold text-fontColor mb-2 text-overFontSize outer-font-color">
            NeedleEye
          </h2>
          <p className="text-fontColor mb-8 leading-relaxed text-base text-primaryFontSize outer-font-color">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque dapibus, arcu a hendrerit cursus, felis mauris egestas
            sapien, at convallis mi eros id nunc. Etiam in sagittis mi, id
            mattis ligula. Donec ut varius mi. Pellentesque euismod aliquam
            felis, in aliquam elit finibus sed. Proin viverra dictum lectus, et
            porttitor odio lobortis ut.
          </p>
          <p className="text-fontColor mb-8 leading-relaxed text-base text-primaryFontSize outer-font-color">
            Donec scelerisque, augue sed molestie aliquet, tellus ante porttitor
            nisi, nec iaculis nibh dolor ac justo. Nulla elementum ipsum sed
            sagittis tincidunt. Curabitur id nibh sit amet enim ultrices cursus
            non in mi. Integer egestas vulputate mauris et ullamcorper. Nam
            suscipit lorem sed odio maximus lacinia. Donec vehicula tortor vel.
            Curabitur cursus, turpis eget porttitor rutrum, orci eros vulputate
            mauris, non elementum justo ante nec justo. Suspendisse efficitur
            risus sit amet ipsum aliquet tincidunt. Ut elementum massa ac sapien
            commodo hendrerit sit amet sit amet augue. Suspendisse blandit augue
            eu purus lacinia, eget mollis ante viverra. Donec a dictum turpis,
            sit amet egestas ipsum. Vivamus imperdiet tincidunt arcu nec
            sagittis. Curabitur id est eget diam porta mattis. Curabitur neque
            dui, vulputate nec auctor ac, sollicitudin a diam. Vestibulum
            malesuada cursus convallis. Vivamus at diam faucibus, scelerisque
            sem facilisis, iaculis ante.
          </p>
          <p className="text-fontColor mb-8 leading-relaxed text-base text-primaryFontSize outer-font-color">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque dapibus, arcu a hendrerit cursus, felis mauris egestas
            sapien, at convallis mi eros id nunc. Etiam in sagittis mi, id
            mattis ligula. Donec ut varius mi. Pellentesque euismod aliquam
            felis, in aliquam elit finibus sed. Proin viverra dictum lectus, et
            porttitor odio lobortis ut.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
     © {new Date().getFullYear() > 2026 ? `2026-${new Date().getFullYear()}` : '2026'}, Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default Moonshots;
